import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import PermissionControlledCard from "../../../../common/PermissionControlledCard";
import { usePermissions } from "../../../../context/PermissionContext";

const ProductGrowthFilter = ({ filterOptions, defaultValueFilter, onApply }) => {
  const [isFilter, setIsFilter] = useState(false)
  const [filters, setFilters] = useState({
    wise: JSON.parse(localStorage.getItem('productGrowthFilters'))?.wise || defaultValueFilter?.range_type,
    comparison: "net_sales",
    range: JSON.parse(localStorage.getItem('productGrowthFilters'))?.range || filterOptions?.weeks?.[0]?.value,
    range_type: "week",
    year: 2025,
    product_ids: [], // store selected product ids
  });

  const selectRef = useRef(null);
  const permission = usePermissions();



  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  const weekAllowed = permission?.data?.product_growth?.filters?.week;
  const monthAllowed = permission?.data?.product_growth?.filters?.month;
  const productsAllowed = permission?.data?.product_growth?.filters?.products;

  // Mark permissions as loaded
  useEffect(() => {
    if (permission?.data?.product_growth) {
      setPermissionsLoaded(true);
    }
  }, [permission]);
  // Load from localStorage on mount

  useEffect(() => {
    if (!permission?.data) return ;

    const week = permission.data.product_growth?.filters?.week;
    const month = permission.data.product_growth?.filters?.month;

    setFilters(prev => {
      let updated = { ...prev };
      let changed = false;

      // CASE 1: Week permission FALSE → force Month
      if (!week?.allowed) {
        if (prev?.wise === "week" || prev?.range_type === "week") {
          updated.wise = "month";
          updated.range_type = "month";
          updated.range = filterOptions?.months?.[0]?.value || "";
          changed = true;
        }
      }

      // CASE 2: Month permission FALSE → force Week
      if (!month?.allowed) {
        if (prev.wise === "month" || prev.range_type === "month") {
          updated.wise = "week";
          updated.range_type = "week";
          updated.range = filterOptions?.weeks?.[0]?.value || "";
          changed = true;
        }
      }

      // If nothing changed → return original
      if (!changed) return prev;

      // Update LocalStorage if changed
      localStorage.setItem("productGrowthFilters", JSON.stringify(updated));

      return updated;
    });

  }, [permission, filterOptions]);

  // Save to localStorage whenever filters change
  useEffect(() => {
    if (!localStorage.getItem("productGrowthFilters")) {
      localStorage.setItem("productGrowthFilters", JSON.stringify(filters));
    }
  }, [filters]);

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  // useEffect(()=>{
  //   isFilter &&  onApply(filters)
  // },[filters,isFilter])

  const handleApply = () => {
    onApply(filters);
  };


  const handlePrint = () => {
    window.print();
  };

  // Initialize Select2
  useEffect(() => {
    if (selectRef.current) {
      $(selectRef.current)
        .select2({
          placeholder: "Select Products",
          multiple: true,
          minimumInputLength: 3,
          ajax: {
            url: "/api/v1/product_growth_analytics/select_product_option",
            dataType: "json",
            delay: 250,
            data: (params) => {
              return {
                query: params.term || "", // dynamic query passed to backend
              };
            },
            processResults: (data) => ({
              results: data.map((item) => ({
                id: item.id,
                text: item.asin ? `${item.asin} (${item.sku})` : item.sku, // asin with sku in parentheses
              })),
            }),
          },
        })
        .on("change", function () {
          const selectedIds = $(this).val() || [];
          handleChange("product_ids", selectedIds);
        });

    }

    return () => {
      if (selectRef.current && $(selectRef.current).data('select2')) {
        $(selectRef.current).select2('destroy');
        // handleChange("product_ids", []);
      }
    };
  }, [filters?.product_ids]);

  // Determine which data to show based on permissions
  const hasWeekPermission = permission?.data?.product_growth?.filters?.week;
  const hasMonthPermission = permission?.data?.product_growth?.filters?.month;

  // Determine actual mode to render (week/month)
  let effectiveWise = filters?.wise;

  // If the user wants "week" but lacks week permission, fallback to month (if allowed)
  if (filters?.wise === "week" && !hasWeekPermission && hasMonthPermission) {
    effectiveWise = "month";
  }

  useEffect(() => {
    if (!permissionsLoaded) return ;
    // if both false => no active tab
    if (!weekAllowed && !monthAllowed) {
      setFilters((prev) => ({ ...prev, wise: "", range_type: "", range: "" }));
      return ; ;
    }

    // if week not allowed but month is => switch to month
    if (!weekAllowed && monthAllowed && filters?.wise === "week") {
      setFilters((prev) => ({
        ...prev,
        wise: "month",
        range_type: "month",
        range: filterOptions?.months?.[0]?.value || "",
      }));
    }

    // if month not allowed but week is => switch to week
    if (!monthAllowed && weekAllowed && filters?.wise === "month") {
      setFilters((prev) => ({
        ...prev,
        wise: "week",
        range_type: "week",
        range: filterOptions?.weeks?.[0]?.value || "",
      }));
    }
  }, [
    permission?.data?.product_growth?.filters,
    filters?.wise,
    filterOptions,
    setFilters
  ]);

  // If both week and month permissions are false → don’t render fields
  const showPeriodFields = hasWeekPermission || hasMonthPermission;

  const setFilterOption = (filterWise) => {
    let updated = { ...JSON.parse(localStorage.getItem("productGrowthFilters")) }
    if (filterWise === 'week') {
      setFilters((prev) => ({
        ...prev,
        wise: "week",
        range_type: "week", // make sure range_type syncs
        range: filterOptions?.weeks?.[0]?.value || "", // reset to first available week
      }))
      updated.wise = "week";
      updated.range_type = "week";
      updated.range = filterOptions?.weeks?.[0]?.value || "";
    }
    else {
      setFilters((prev) => ({
        ...prev,
        wise: "month",
        range_type: "month", // sync range_type
        range: filterOptions?.months?.[0]?.value || "", // reset to first available month
      }))
      updated.wise = "month";
      updated.range_type = "month";
      updated.range = filterOptions?.months?.[0]?.value || "";
    }
    localStorage.setItem("productGrowthFilters", JSON.stringify(updated));
  }

  return (
    <div className="card shadow-sm mt-2 skip-print">
      {filterOptions !== null && (
        <div className="card-body h-auto">
          <div className="d-flex flex-wrap align-items-center gap-3">
            {/* <h5 className="mb-0 fw-semibold kpi-heading">Product Growth Filters</h5> */}
            <div className="toggle-tab">
              <ul className="nav nav-tabs custom-nav-tabs kpi-name">
                <li className="nav-item">
                  <PermissionControlledCard permission={permission?.data?.product_growth?.filters?.week} colClass=''>
                    <button
                      disabled={!permission?.data?.product_growth?.filters?.week}
                      className={`nav-link pg-matric ${filters?.wise === "week" ? "active" : ""}`}
                      onClick={() => { setFilterOption("week") }}
                    >
                      Week
                    </button>
                  </PermissionControlledCard>
                </li>
                <li className="nav-item">
                  <PermissionControlledCard permission={permission?.data?.product_growth?.filters?.month} colClass=''>
                    <button
                      disabled={!permission?.data?.product_growth?.filters?.month}
                      className={`nav-link pg-matric ${filters?.wise === "month" ? "active" : ""}`}
                      onClick={() => { setFilterOption("month") }}

                    >
                      Month
                    </button>
                  </PermissionControlledCard>
                </li>
              </ul>
            </div>
          </div>

          <div className="row g-3 mt-1">

            {showPeriodFields && (
              <PermissionControlledCard permission={filters?.wise === "month" ? permission?.data?.product_growth?.filters?.month : permission?.data?.product_growth?.filters?.week} colClass='col-md-2'>
                <div className="col-md-12">
                  <select
                    className="form-select"
                    value={filters?.comparison}
                    onChange={(e) => handleChange("comparison", e.target.value)}
                  >
                    {(filterOptions?.comparison || []).map((c) => (
                      <option key={c.value} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </select>
                </div>
              </PermissionControlledCard>
            )}

            {/* Period (Week/Month) — fallback to month if week not allowed */}
            {showPeriodFields && (
              <PermissionControlledCard permission={filters?.wise === "month" ? permission?.data?.product_growth?.filters?.month : permission?.data?.product_growth?.filters?.week} colClass='col-md-2'>
                <div className="col-md-12">
                  <select
                    className="form-select"
                    value={filters?.range}
                    onChange={(e) => handleChange("range", e.target.value)}
                  >
                    {/* {(effectiveWise === "week" 
          ? filterOptions?.weeks || []
          : filterOptions?.months || []
        ).map((item) => (
          <option key={item.value} value={item.value}>
            {`${item.name} (${item.year})`}
          </option>
        ))} */}
                    {(
                      (effectiveWise === null || effectiveWise === "")
                        ? (permission?.data?.product_growth?.filters?.month?.allowed === false
                          ? filterOptions?.weeks
                          : filterOptions?.months)
                        : (effectiveWise === "week"
                          ? filterOptions?.weeks
                          : filterOptions?.months)
                    )?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {`${item.name} (${item.year})`}
                      </option>
                    ))}
                  </select>
                </div>
              </PermissionControlledCard>
            )}

            {/* Product Select2 */}
            {/* {permission?.data?.product_growth?.filters?.products && ( */}
            <PermissionControlledCard permission={permission?.data?.product_growth?.filters?.products} colClass='col-md-6'>
              <div className="col-md-12">
                <select ref={selectRef} className="form-control mt-2" multiple></select>
              </div>
            </PermissionControlledCard>
            {/* )} */}

            {/* Action */}
            <div
              className={`${
                // Adjust width dynamically if some fields are hidden
                [
                  (filters?.wise === "week" &&
                    permission?.data?.product_growth?.filters?.week) ||
                    (filters?.wise === "month" &&
                      permission?.data?.product_growth?.filters?.month)
                    ? "col-lg-2"
                    : "col-lg-2",
                ].join(" ")
                } col-12`}
            >
              {/* <PermissionControlledCard permission={permission?.data?.product_growth?.filters?.products} colClass=''> */}
              <div className="action-button">
                <button
                  className="btn plan-detail-card-btn me-2 d-inline"
                  type="button"
                  onClick={handleApply}
                >
                  Filter
                </button>
                <button onClick={handlePrint} className="btn plan-detail-card-btn d-inline print-skip">
                  <i class="bi bi-printer"></i>
                </button>
              </div>
              {/* </PermissionControlledCard> */}
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default ProductGrowthFilter;
